module.exports = __webpack_public_path__ + "img/microphone_green.1359c63a.png";